import React from 'react'

type Props = {}

function BlockCourtIcon(props: any) {
  return (
   <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"  {...props}>
<path d="M14 4C19.5228 4 24 8.47715 24 14C23.9999 19.5228 19.5228 24 14 24C8.47729 23.9999 4.00011 19.5227 4 14C4 10.2414 6.07397 6.96713 9.13965 5.25879L9.73242 6.51465C7.13561 7.99844 5.38574 10.795 5.38574 14C5.38579 16.1103 6.14563 18.0422 7.40527 19.54L19.6201 7.47363C18.1113 6.17317 16.1482 5.38477 14 5.38477C13.1915 5.38478 12.409 5.49682 11.667 5.70508L11.2256 4.38965C12.1064 4.13585 13.0375 4.00001 14 4ZM8.37988 20.5254C9.8887 21.8261 11.8517 22.6142 14 22.6143C18.7577 22.6143 22.6151 18.7577 22.6152 14C22.6152 11.8889 21.8542 9.95613 20.5938 8.45801L8.37988 20.5254Z" fill="#EF4626"/>
</svg>

  )
}

export default BlockCourtIcon